module.exports = __webpack_public_path__ + "img/rv-park--full.f26d16ec.png";